import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetServerSidePropsContext } from "next";
import { NextPage } from "next";
import BriefingPage from "components/pages/Briefing";
import { QueryClient, dehydrate } from "@tanstack/react-query";

interface Props {
  isMobile: boolean;
}

const Briefing: NextPage<Props> = ({ isMobile }) => {
  return <BriefingPage isMobile={isMobile} />;
};
export default Briefing;

export async function getServerSideProps({
  locale,
  req,
}: GetServerSidePropsContext) {
  const base = process.env.NEXTAUTH_URL || `http://${req.headers.host}`;

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
        refetchOnWindowFocus: false,
      },
    },
  });

  try {
    await queryClient.prefetchQuery({
      queryKey: ["briefing", "data"],
      queryFn: async () => {
        const response = await fetch(`${base}/api/briefing`);
        if (!response.ok) throw new Error("briefing fetch failed");
        return response.json();
      },
    });
  } catch (error) {
    console.error("briefing prefetch failed:", error);
  }

  const dehydratedState = dehydrate(queryClient);
  const cleanDehydratedState = JSON.parse(
    JSON.stringify(dehydratedState, (_key, value) =>
      value === undefined ? null : value
    )
  );

  return {
    props: {
      dehydratedState: cleanDehydratedState,
      ...(await serverSideTranslations((locale || "ko") as string, ["main"])),
    },
  };
}
